import zh_CN from 'antd/es/locale-provider/zh_CN';
import en_US from 'antd/es/locale-provider/en_US';

import { createIntl, createIntlCache } from 'react-intl';
import * as Cookies from 'js-cookie';
import enJson from './en.json';
import zhJson from './zh.json';


export const K_LOCALE_UPDATED = 'framely-locale-updated';

export let locales: { [key: string]: any } = {
  en: {
    localeStr: 'en',
    antdLocale: {
      ...en_US,
      Modal: {
        okText: 'Save',
        cancelText: 'Cancel'
      }
    },
    messages: enJson
  },
  zh: {
    localeStr: 'zh',
    antdLocale: {
      ...zh_CN,
      Modal: {
        okText: '保存',
        cancelText: '取消'
      }
    },
    messages: zhJson
  }
};

const intls: any = {
  en: undefined,
  zh: undefined
};

const K_LOCALE = 'locale';

export function setLocale(locale: any) {
  window.localStorage.setItem(K_LOCALE, JSON.stringify(locale));
  setSessionLocale(locale);
  Cookies.set('framely-locale', locale.localeStr);
}

function setSessionLocale(locale?: any) {
  if (locale) {
    window.sessionStorage.setItem(K_LOCALE, JSON.stringify(locale));
  } else {
    window.sessionStorage.removeItem(K_LOCALE);
  }
}

export function getLocale() {
  const lang = 'en';
  const defaultLocale = locales[lang];
  setLocale(defaultLocale);
  return defaultLocale;
}

export function localizedString(id: any, values?: any, defaultMessage?: string) {

  let intl = intls[getLocale().localeStr];
  if (!intl) {
    intl = createIntl({
      locale: getLocale().localeStr,
      messages: getLocale().messages
    });

    intls[getLocale().localeStr] = intl;
  }

  const { formatMessage } = intl;
  return formatMessage({ id, defaultMessage }, values);
}
